export default "__VITE_ASSET__BJhFK$QC__"